
import { supabase } from './supabaseClient';
import { UserProfile } from '../types';

export const authService = {
  async signIn(email: string, pass: string) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email.trim().toLowerCase(),
      password: pass,
    });
    if (error) throw error;
    return data.user;
  },

  async signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  },

  async getSession() {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) throw error;
    return session;
  },

  async getUserProfile(userId: string): Promise<UserProfile | null> {
    const { data, error } = await supabase
      .from('empresa_usuarios')
      .select('*, empresas(*, planos(*))')
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      console.error('Error fetching user profile:', error.message);
      return null;
    }

    if (data && data.empresas) {
      const emp = Array.isArray(data.empresas) ? data.empresas[0] : data.empresas;
      const plan = emp.planos ? (Array.isArray(emp.planos) ? emp.planos[0] : emp.planos) : null;
      
      data.empresas = {
        ...emp,
        plano: (plan?.slug || emp.plano || 'ESSENCIAL').toUpperCase(),
        permite_relatorios: plan?.permite_relatorios ?? emp.permite_relatorios ?? false,
        permite_dashboard_avancado: plan?.permite_dashboard_avancado ?? emp.permite_dashboard_avancado ?? false
      };
    }

    return data;
  },

  async updateUser(userId: string, data: { senha?: string, nome?: string }) {
    if (data.senha) {
      const { error } = await supabase.auth.updateUser({
        password: data.senha
      });
      if (error) throw error;
    }

    if (data.nome) {
      const { error } = await supabase.auth.updateUser({
        data: { nome: data.nome }
      });
      if (error) throw error;
    }
  }
};
